import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CalendarIcon from '../../../../icons/calendar.svg'
import Calendar from 'react-calendar'
import moment from 'moment'
import styles from '../../../Pages/Common/Footer/footer.module.scss'
import RightArrow from '../../../../icons/rightArrowIcon.svg'
import LeftArrow from '../../../../icons/leftArrowIcon.svg'
import { reasonsOfAbsence } from '../../../../constants/lists/relationshipList'
import { setAuthorizedPerson } from '../../../../redux/actions/careReceipients'
import { setAuthPerson } from '../../../../redux/actions/quizQuestions'
import ArrowBtn from '../../../../icons/arrowBtn.svg'
import cx from 'classnames'
import { handlePhoneNumberFieldChange } from '../../../../redux/actions/Auth'
import PhoneNumberField from '../../../ReusableField/PhoneNumberField'

const AuthorizePerson = ({ parentState, setParentState }) => {
  const currentDate = new Date()
  const {
    quizAuthorizedPerson: { quizAuth, indexAuth },
    startFromJuly,
  } = useSelector((state) => state.quizQuestions)
  const { authorizedPerson, legalRepresentations, careReceipients } = useSelector(
    (state) => state,
  )
  const [showCalendar, setShowCalendar] = useState(false)
  const { selectedLanguage } = useSelector((state) => state.metadata)
  const { phoneNumberObj } = useSelector((state) => state.auth)
  const [option, setOption] = useState(false)
  const dispatch = useDispatch()
  const wrapperRef = useRef(null)
  const wrapper = useRef(null)
  const buttonGroupRefAuth = useRef(null) // Move this to your component scope
  const date = moment(new Date()).format('dd.MM.yyyy')
  useEffect(() => {}, [careReceipients, legalRepresentations, authorizedPerson])
  useEffect(() => {}, [authorizedPerson.professionalCarer])
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])
  useEffect(() => {
    document.addEventListener('click', handleClickOut, false)
    return () => {
      document.removeEventListener('click', handleClickOut, false)
    }
  }, [])
  const handleClickOut = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      setShowCalendar(false)
    }
  }
  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOption(false)
    }
  }
  const handleClick = (e) => {
    const buttons = buttonGroupRefAuth.current?.querySelectorAll(
      'input[type="submit"]',
    )
    buttons?.forEach((btn) => btn.classList.remove(styles.active))
    e.target.classList.add(styles.active)
    handleChange(e) // Your original handler
  }
  const handleChange = (e) => {
    setParentState(e.currentTarget.value)
  }
  const handleAuthAnswer = () => {
    if (!parentState) return
    const newQuiz = quizAuth.map((item, i) => {
      if (i === indexAuth) {
        return {
          ...item,
          // answers: parentState,
          answers:
            item.type === 'phoneNumber'
              ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
              : parentState,
          returnQuestion:
            item.question ===
              'Weshalb ist die Person verhindert ?  Bitte wählen Sie einen Grund aus der Liste aus.' &&
            parentState
              ? 'Vielen Dank für die Informationen. Nun geht es um die Person, die statt der verhinderten Person die Pflege übernommen hat oder übernehmen wird.'
              : item.question ===
                    'Wird die verhinderte Pflegeperson vom Pflegebedürftigen als Pfleger bezahlt oder ist sogar eine Pflegefirma ?' &&
                  parentState === 'Ja'
                ? 'Erstattung von Verhinderungspflege ist nur möglich bei Verhinderung eines privaten, nicht für den Berechtigten gewerblich tätigen Pflegeperson.'
                : item.question ===
                      'Wie lange hat die verhinderte Pflegeperson schon den Antragsteller gepflegt ?' &&
                    parentState === 'Unter 6 monate'
                  ? 'Erstattung der Verhinderungspflege ist erst ab 6 Monaten Vorpflegezeit möglich.'
                  : '',
          returnLink:
            (item.question ===
              'Wird die verhinderte Pflegeperson vom Pflegebedürftigen als Pfleger bezahlt oder ist sogar eine Pflegefirma ?' &&
              parentState === 'Ja') ||
            (item.question ===
              'Wie lange hat die verhinderte Pflegeperson schon den Antragsteller gepflegt ?' &&
              parentState === 'Unter 6 monate')
              ? 'https://flexxi.care/de/vhp#faq'
              : null,
          //
          // parentState === 'Ja'  || parentState === 'Unter 6 monate' ?
          //     'Reimbursement of costs for respite care is not possible for commercial carers and care companies' :'',
        }
      }
      return item
    })
    dispatch(
      setAuthorizedPerson(
        Object.keys(authorizedPerson)[indexAuth],
        Object.keys(authorizedPerson)[indexAuth] === 'phoneNumber'
          ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
          : parentState,
      ),
    )
    dispatch(setAuthPerson(newQuiz, indexAuth + 1))
    dispatch(
      handlePhoneNumberFieldChange({
        countryCode: 'DE',
        callingCode: '49',
        number: '',
      }),
    )
    setParentState('')
  }
  const authOption = () => {
    if (!option) {
      setOption(true)
    } else {
      setOption(false)
    }
  }
  const clickAuthOption = (e) => {
    setParentState(e.target.innerText)
    setOption(false)
  }
  const handleChangeNumber = (e) => {
    if (/^\d*$/.test(e.currentTarget.value)) {
      if (e.currentTarget.value.length <= 5) {
        setParentState(e.currentTarget.value)
      }
    }
  }
  const handleChangeAuthCalendar = (e) => {
    setParentState(moment(e).format('DD.MM.YYYY'))
    setShowCalendar(false)
  }
  const convertToDate = (dateString) => {
    const [day, month, year] = dateString.split('.')
    const date = new Date(year, month - 1, day)
    return date.toString()
  }
  // console.log(convertToDate(answerAuth));
  const handleShowAuthCalendar = () => {
    if (!showCalendar) {
      setShowCalendar(true)
    } else {
      setShowCalendar(false)
    }
  }
  const handleChangePhone = (newPhoneNumberObj) => {
    dispatch(handlePhoneNumberFieldChange(newPhoneNumberObj))
  }
  const maxYear = new Date().getFullYear()
  const formatDate = (value) => {
    value = value.replace(/[^\d.]/g, '')

    if (value.length > 10) return parentState

    let parts = value.split('.')
    let day = parts[0] || ''
    let month = parts[1] || ''
    let year = parts[2] || ''

    if (day.length > 2) {
      month = day.slice(2) + (month ? '.' + month : '')
      day = day.slice(0, 2)
    }
    if (Number(day) > 31) day = '31'

    // Format month (01-12)
    if (month.length > 2) {
      year = month.slice(2) + (year ? '.' + year : '')
      month = month.slice(0, 2)
    }
    if (Number(month) > 12) month = '12'

    if (year.length > 4) year = year.slice(0, 4)
    if (year && Number(year) > maxYear) year = maxYear.toString()

    let formattedDate = day
    if (month) formattedDate += '.' + month
    if (year) formattedDate += '.' + year

    return formattedDate
  }
  const cleanedInput = parentState?.trim() || ''
  const isValidDate = (value) => {
    const parts = value.split('.')
    if (parts.length !== 3) return false

    const [day, month, year] = parts.map(Number)

    return (
      day >= 1 &&
      day <= 31 &&
      month >= 1 &&
      month <= 12 &&
      year >= 1000 &&
      year <= 9999 // Only allow 4-digit year
    )
  }

  const endsWithPDF = (value) => {
    return value.slice(-3).toLowerCase() === 'pdf'
  }

  const isButtonDisabled = !(
    (quizAuth[indexAuth]?.type === 'birthDay'
      ? parentState?.length === 10 && isValidDate(parentState)
      : quizAuth[indexAuth]?.type === 'number'
        ? parentState?.length === 5
        : parentState) || endsWithPDF(cleanedInput)
  )
  const handleChangeBirthday = (e) => {
    const newValue = formatDate(e.currentTarget.value)
    setParentState(newValue)
  }

  return (
    <>
      {quizAuth?.map((item, i) => {
        if (i === indexAuth) {
          switch (item?.type) {
            case 'text':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentState) handleAuthAnswer()
                  }}
                  autoFocus={true}
                />
              )
            case 'number':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChangeNumber(e)}
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' &&
                      parentState &&
                      parentState?.length === 5
                    )
                      handleAuthAnswer()
                  }}
                  autoFocus={true}
                />
              )
            case 'phoneNumber':
              return (
                <PhoneNumberField
                  onChange={handleChangePhone}
                  phoneNumberObj={phoneNumberObj}
                  setAnswerr={setParentState}
                  handleonKeyDown={handleAuthAnswer}
                />
              )
            case 'date':
              return (
                <div>
                  <input
                    placeholder="Datum auswählen"
                    value={
                      !parentState
                        ? moment(
                            new Date(
                              moment().year(),
                              moment().month(),
                              moment().date(),
                            ),
                          ).format('DD.MM.YYYY')
                        : moment(convertToDate(parentState)).format('DD.MM.YYYY')
                    }
                    required
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handleAuthAnswer()
                    }}
                    autoFocus={true}
                    onClick={handleShowAuthCalendar}
                  />
                  <img
                    src={CalendarIcon}
                    alt={CalendarIcon}
                    onClick={handleShowAuthCalendar}
                  />
                  {!!showCalendar && (
                    <Calendar
                      onChange={(e) => handleChangeAuthCalendar(e)}
                      value={
                        !parentState
                          ? new Date(
                              moment().year(),
                              moment().month(),
                              moment().date(),
                            )
                          : authorizedPerson?.periodOfAbsenceFrom
                            ? new Date(
                                convertToDate(authorizedPerson?.periodOfAbsenceFrom),
                              )
                            : convertToDate(parentState)
                      }
                      className={styles.reactCalendar}
                      minDate={
                        startFromJuly && !authorizedPerson?.periodOfAbsenceFrom
                          ? new Date(convertToDate('01.07.2025'))
                          : item.question === 'Und bis wann ?' &&
                            new Date(
                              convertToDate(authorizedPerson?.periodOfAbsenceFrom),
                            )
                      }
                      maxDate={
                        !startFromJuly &&
                        item.question !== 'Und bis wann ?' &&
                        new Date(convertToDate('30.06.2025'))
                      }
                      nextLabel={<img src={RightArrow} alt={'next'} />}
                      prevLabel={<img src={LeftArrow} alt={'Previous'} />}
                      next2Label={null}
                      prev2Label={null}
                      tileDisabled={({ date, view }) => {
                        if (view === 'year') {
                          return (
                            date.getFullYear() > currentDate.getFullYear() ||
                            (date.getFullYear() === currentDate.getFullYear() &&
                              date.getMonth() > currentDate.getMonth())
                          )
                        }
                        return false
                      }}
                      locale={'de'}
                    />
                  )}
                </div>
              )
            case 'birthDay':
              return (
                <div>
                  <input
                    placeholder={'Datum auswählen'}
                    value={parentState}
                    required
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !isButtonDisabled) handleAuthAnswer()
                    }}
                    autoFocus={true}
                    onChange={(e) => handleChangeBirthday(e)}
                  />
                  <img
                    src={CalendarIcon}
                    alt={CalendarIcon}
                    onClick={handleShowAuthCalendar}
                  />
                  {!!showCalendar && (
                    <Calendar
                      onChange={(e) => handleChangeAuthCalendar(e)}
                      value={
                        !parentState || parentState?.length !== 10
                          ? new Date(
                              moment().year(),
                              moment().month(),
                              moment().date(),
                            )
                          : convertToDate(parentState)
                      }
                      maxDate={new Date()}
                      className={styles.reactCalendar}
                      nextLabel={<img src={RightArrow} alt={'next'} />}
                      prevLabel={<img src={LeftArrow} alt={'Previous'} />}
                      next2Label={null}
                      prev2Label={null}
                      tileDisabled={({ date, view }) => {
                        if (view === 'year') {
                          return (
                            date.getFullYear() > currentDate.getFullYear() ||
                            (date.getFullYear() === currentDate.getFullYear() &&
                              date.getMonth() > currentDate.getMonth())
                          )
                        }
                        return false
                      }}
                      locale={'de'}
                    />
                  )}
                </div>
              )
            case 'option':
              return (
                <div className={styles.optionHid}>
                  <div
                    className={cx(styles.select, {
                      [styles.placeholder]: parentState,
                    })}
                    onClick={authOption}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handleAuthAnswer()
                    }}
                    ref={wrapperRef}
                  >
                    {parentState ? parentState : 'Bitte wählen Sie'}
                  </div>
                  {!!option && (
                    <div className={styles.option}>
                      {reasonsOfAbsence.map((item) => {
                        return <div onClick={clickAuthOption}>{item}</div>
                      })}
                    </div>
                  )}
                </div>
              )
            case 'submit':
              return (
                <span ref={buttonGroupRefAuth}>
                  <input
                    type={'submit'}
                    placeholder={'Geben Sie eine Antwort ein.'}
                    value={
                      item.question ===
                      'Wird die verhinderte Pflegeperson vom Pflegebedürftigen als Pfleger bezahlt oder ist sogar eine Pflegefirma ?'
                        ? 'Ja'
                        : item.question ===
                            'Wie lange hat die verhinderte Pflegeperson schon den Antragsteller gepflegt ?'
                          ? 'Unter 6 monate'
                          : 'unter 8 Stunden täglich'
                    }
                    onClick={handleClick}
                    className={styles.care}
                  />
                  <input
                    type={'submit'}
                    placeholder={'Geben Sie eine Antwort ein.'}
                    value={
                      item.question ===
                      'Wird die verhinderte Pflegeperson vom Pflegebedürftigen als Pfleger bezahlt oder ist sogar eine Pflegefirma ?'
                        ? 'Nein'
                        : item.question ===
                            'Wie lange hat die verhinderte Pflegeperson schon den Antragsteller gepflegt ?'
                          ? 'über 6 Monate'
                          : 'über 8 Stunden täglich'
                    }
                    onClick={handleClick}
                    className={styles.care}
                    autoFocus={true}
                  />
                </span>
              )
          }
        }
      })}
      {!authorizedPerson.reasonForTheAbsence && (
        <button
          disabled={isButtonDisabled}
          className={cx({
            [styles.btnDisabled]: isButtonDisabled,
          })}
          onClick={handleAuthAnswer}
        >
          <img src={ArrowBtn} alt={ArrowBtn} />
        </button>
      )}
    </>
  )
}
export default AuthorizePerson
